import SimpleModal from '../../../components/SimpleModal';
import { Button, Box } from '@mui/material';
export default function DeleteOffer({
  open,
  initialData,
  handleClose,
  onSubmit,
}) {
  return (
    <>
      <SimpleModal open={open} handleClose={handleClose}>
        <Box>
          Do you want to delete this offer?
          <Button
            variant="contained"
            onClick={() => onSubmit(initialData, handleClose)}
            fullWidth
          >
            Confirm
          </Button>
        </Box>
      </SimpleModal>
    </>
  );
}
